"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMenuAnimationDirection = exports.getMenuAnimation = void 0;
var _core = require("@emotion/core");
const getMenuAnimationDirection = placement => {
  switch (placement) {
    case "top-start":
    case "top":
    case "top-end":
      return "bottom";
    case "right-start":
    case "right":
    case "right-end":
      return "left";
    case "left-end":
    case "left":
    case "left-start":
      return "right";
    case "bottom-end":
    case "bottom":
    case "bottom-start":
    default:
      return "top";
  }
};

// only to be used with Ursa
exports.getMenuAnimationDirection = getMenuAnimationDirection;
const getMenuAnimation = placement => (0, _core.keyframes)`
    from {
        margin-${getMenuAnimationDirection(placement)}: -8px;
    } to {
        margin-${getMenuAnimationDirection(placement)}: 0px;
    }
`;
exports.getMenuAnimation = getMenuAnimation;
//# sourceMappingURL=getMenuAnimation.js.map